import { render } from "./MdlThroughput-nuevo.vue?vue&type=template&id=7892853f&scoped=true"
import script from "./MdlThroughput-nuevo.vue?vue&type=script&lang=js"
export * from "./MdlThroughput-nuevo.vue?vue&type=script&lang=js"

import "./MdlThroughput-nuevo.vue?vue&type=style&index=0&id=7892853f&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7892853f"]])

export default __exports__